import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=55f39752&scoped=true&"
import script from "./PdfViewer.vue?vue&type=script&lang=ts&"
export * from "./PdfViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=55f39752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f39752",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow,VSpacer})
